import { Grid } from "@mui/material";
import React from "react";
import "./pagetitle.scss";
import MDTypography from "components/MDTypography";

function PageTitle({ ...props }) {
  return (
    <Grid className="bootstrap-wrapper page-title">
      <Grid container>
        <Grid item xs={12} md={6} xl={11} lg={11}>
          <Grid item className="title">
            <MDTypography>{props.title}</MDTypography>
          </Grid>
        </Grid>
        <Grid item xs={12} xl={1} lg={1}>
          <Grid item className="right " xl={12} lg={12}>
            {props.children}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PageTitle;
